import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";

let departmentOptions = [];
let locationOptions = [];
function UserLocationTableRow({ key,loginId, companyId, userDepartments, handleSubmit, setError, t, setAdd, setIsLocationLoading, oddIdx }) {
	const navigate = useNavigate();
	const [departmentLoaded, setDepartmentLoaded] = useState(false);
	const [departmentSelected, setDepartmentSelected] = useState({ name: "departmentKey", label: "", value: 0 });

	const [locationLoaded, setLocationLoaded] = useState(false);
	const [locationSelected, setLocationSelected] = useState({ name: "locationKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const userCtx = useContext(UserContext);
	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		setDepartmentValues(userDepartments);
	}, []);

	function setDepartmentValues(departmentObj) {
		let departmentValue = {};
		departmentOptions = [];
		departmentOptions.push({ label: "", value: 0 });
		if (departmentObj && departmentObj.length > 0) {
			departmentObj.map((aDepartment, idx) => {
				departmentValue.label = aDepartment.departmentName;
				departmentValue.value = aDepartment.departmentKey;
				departmentOptions.push(departmentValue);
				departmentValue = {};
			});
			setDepartmentLoaded(true);
		}
	}
	const departmentHandler = (selectedOption, action) => {
		let departmentKey = selectedOption ? selectedOption.value : 0;
		let departmentName = selectedOption ? selectedOption.label : "";
		setDepartmentSelected({ ...departmentSelected, label: (departmentName), value: departmentKey });
		if (!departmentKey || departmentKey === 0) {
			locationOptions = [];
			setLocationSelected({ ...locationSelected, label: "", value: 0 });
		} else {
			fetchCompanyLocations(departmentKey);
		}
	}
	const locationHandler = (selectedOption, action) => {
		let locationKey = selectedOption ? selectedOption.value : 0;
		let locationName = selectedOption ? selectedOption.label : "";
		setLocationSelected({ ...locationSelected, label: (locationName), value: locationKey });
	}

	function fetchCompanyLocations(departmentKey) {
		setError("");
		if (!companyId || companyId === 0 || !departmentKey || departmentKey === 0) {
			return;
		}

		setIsLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				companyId: companyId, departmentKey: departmentKey
			}),
		};
		try {
			FetchUtil.fetchAPI("GetWorkLocations", "/Service/CompanyService/GetWorkLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
		} catch (error) {
			setIsLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveWorkLocationFail(redirect) {
		setIsLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.locNotRetrieved"));
	}

	function retrieveWorkLocationSuccess(responseData) {
		let fetchWorkLocationsResponse;
		if (responseData) {
			fetchWorkLocationsResponse = responseData.fetchWorkLocationsResponse;
			if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "0") {
				setLocationValues(fetchWorkLocationsResponse.locations.slice());
			} else if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchWorkLocationsResponse) {
				setError(t("error.error") + " " + fetchWorkLocationsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsLocationLoading(false);
	}

	function setLocationValues(locationObj) {
		let locationValue = {};
		locationOptions = [];
		locationOptions.push({ label: "", value: 0 });
		if (locationObj && locationObj.length > 0) {
			locationObj.map((aLoc, idx) => {
				locationValue.label = aLoc.locationName;
				locationValue.value = aLoc.locationKey;
				locationOptions.push(locationValue);
				locationValue = {};
			});
			setLocationLoaded(true);
		}
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			departmentKey: departmentSelected.value,
			locationKey: locationSelected.value
		};

		if (!departmentSelected.value || departmentSelected.value === 0) {
			setError(t("error.deptNameReqd"));
			setIsSubmit(false);
		} else if (!locationSelected.value || locationSelected.value === 0) {
			setError(t("error.locNameReqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{departmentLoaded ? <Select
					name="departmentKey"
					options={departmentOptions}
					onChange={departmentHandler}
					placeholder={""}
					value={departmentSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="departmentKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{locationLoaded ? <Select
					name="locationKey"
					options={locationOptions}
					onChange={locationHandler}
					placeholder={""}
					value={locationSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="locationKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(departmentOptions && departmentOptions.length >0 && locationOptions && locationOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserLocationTableRow;